import PosthogService from '~/services/posthog/PosthogService';

/**
 * Fires when an office clicks on the Action Needed tab on the Shifts Overview page
 * Event: dental_portal:shifts_overview:action_needed_tab_clicked
 */
export function fireShiftsOverviewActionNeededTabClicked(): void {
  PosthogService.getInstance().track('dental_portal:shifts_overview:action_needed_tab_clicked');
}
